module.exports = __webpack_public_path__ + "static/media/egg.8883dd75.svg";